import React, { useState } from 'react';
import '../../../style.css';

const MeetingCards = (props) =>
{
	const { setMeet, handleInstant } = props;

	const handleJoin = () =>
	{
		setMeet('JoinMeet');
	};

	return (
		<>
			<div className='flexRow pdngBSM'>
				<div className='halfWidth pdngXS'>
					<div className='flexAutoCol mtngIconsBg brdrRadiusLSM pdngMD aCntr' onClick={handleJoin}>
						<div className='mtngIcons pointer'>
							<img src='/icons/joinmeetIcon.svg' alt='joinmeeting' />
						</div>
						<span className='graytextcolor pdngTXXS'>Join Meeting</span>
					</div>
				</div>
				<div className='halfWidth pdngXS'>
					<div className='flexAutoCol mtngIconsBg brdrRadiusLSM pdngMD aCntr' onClick={handleInstant}>
						<div className='mtngIcons pointer'>
							<img src='/icons/instameetIcon.svg' alt='instameeting' />
						</div>
						<span className='graytextcolor pdngTXXS'>Instant Meeting</span>
					</div>
				</div>
			</div>
			{/* {joinMeet && <JoinMeeting handleCloseMeet={handleCloseMeet} setJoinMeet={setJoinMeet} joinMeet={joinMeet}/>}
			{instantMeet && <InstantMeeting handleCloseMeet={handleCloseMeet} setInstantMeet={setInstantMeet}/>} */}
		</>
	);
};

export default MeetingCards;